import { useSlate } from 'slate-react';
import ColorPicker from '../../../../../RichTextEditorV2/Elements/ColorPicker/ColorPicker';

export const HighlightColorTool = () => {
  const editor = useSlate();
  return <ColorPicker format="bgColor" editor={editor} />;
};
